import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ContentBank from "./ContentBank";
import * as PathRouter from '../../../models/PathRoute';
import { ClassificationEnum } from "../../../models/ClassificationContentBankEnum";
import { FilterTypesEnum } from "./FilterAPI/FilterTypesEnum";
import { ObjectTypeEnum, ObjectTypeNamesEnum } from "../../../models/ObjectTypeEnum";
import UploadContentBankItem from "./Upload/UploadContentBankItem/UploadContentBankItem";
import ProjectTypeData from "./MyMaterials/ProjectTypeData";
import { getObjectTypeName, lessonsApi, projectsApi } from "../../../utils";
import UploadAuxiliary from "./Upload/UploadAuxiliary/UploadAuxiliary";
import LessonTypeData from "./MyMaterials/LessonTypeData"
import { useNavigate } from "react-router-dom";
import FilesPopup from "../../lms-shared/UI/Popups/FilesPopup/FilesPopup";
import { DynamicMessageTypeEnum } from "../../lms-shared/models/DynamicMessageTypeEnum";
import DynamicMessage from "../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";

const ContentBankWrapper = ({ fromPopup, selectedMaterial, setSelectedMaterial }) => {

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const applicationId = useSelector(state => state.application.applicationId);
    const uiData = useSelector((state) => state.general.uiData);
    const navigate = useNavigate()
    const [myMaterialList, setMyMaterialList] = useState(null)
    const [message, setMessage] = useState()
    const [addItem, setAddItem] = useState()
    const [isFetching, setIsFetching] = useState(false);
    const [listFilter, setListFilter] = useState([
        {
            "name": "project", "filters": {
                free: { list: null, type: FilterTypesEnum.free, title: texts.freeFilter },
                // curriculum: { list: ["D", "E"], type: FilterTypesEnum.select, title: texts.curriculumFilter },
                // standard: { list: ["E", "F"], type: FilterTypesEnum.select, title: texts.standardFilter },
                // dependencyStandard: { list: ["J", "K"], type: FilterTypesEnum.select, title: texts.dependencyStandardilter },
                refObjectType: { list: [{ text: texts.drafts, value: ObjectTypeEnum.Application }, { text: texts.assignments, value: ObjectTypeEnum.Assessment }], type: FilterTypesEnum.buttons, title: texts.projectType, hideClear: true },
                ideId: { list: [{ text: texts.MakeCode, value: 1 }, { text: texts.Scratch, value: 2 }, { text: texts.EduBot, value: 3 }, { text: texts.Zcode, value: 4 }], type: FilterTypesEnum.buttons, title: texts.ide },
                lang: { list: [{ text: texts.without, value: texts.without }, { text: texts.en, value: "en" }], type: FilterTypesEnum.buttons, title: texts.lang },
                // tag: { list: ["שברים", "חשבון"], type: FilterTypesEnum.tags, title: texts.tagFilter }
            },
            disable: fromPopup === ClassificationEnum.lesson
        },
        {
            "name": "auxiliary", "filters": {
                free: { list: null, type: FilterTypesEnum.free, title: texts.freeFilter },
                lang: { list: [{ text: texts.without, value: texts.without }, { text: texts.ar, value: "ar" }, { text: texts.he, value: "he" }], type: FilterTypesEnum.buttons, title: texts.lang },
                // curriculum: { list: ["L", "M"], type: FilterTypesEnum.select, title: texts.curriculumFilter },
                // standard: { list: ["I", "J"], type: FilterTypesEnum.select, title: texts.standardFilter },
                // dependencyStandard: { list: null, type: FilterTypesEnum.select, title: texts.dependencyStandardilter },
                // file: { list: ["M", "N"], type: FilterTypesEnum.buttons, title: texts.fileFilter },
                // tag: { list: ["N", "O"], type: FilterTypesEnum.tags, title: texts.tagFilter }
            },
            disable: fromPopup || uiData.hidecb,
        }, {
            "name": "lesson", "filters": {
                free: { list: null, type: FilterTypesEnum.free, title: texts.freeFilter },
                // curriculum: { list: ["O", "P"], type: FilterTypesEnum.select, title: texts.curriculumFilter },
                // standard: { list: ["A", "B"], type: FilterTypesEnum.select, title: texts.standardFilter },
                // dependencyStandard: { list: null, type: FilterTypesEnum.select, title: texts.dependencyStandardilter },
                ideId: { list: [{ text: texts.MakeCode, value: 1 }, { text: texts.Scratch, value: 2 }, { text: texts.EduBot, value: 3 }, { text: texts.Zcode, value: 4 }], type: FilterTypesEnum.buttons, title: texts.ide },
                // lang: { list: [{ text: texts.without, value: texts.without }, { text: texts.en, value: "en" }], type: FilterTypesEnum.buttons, title: texts.lang },
                // tag: { list: ["P", "Q"], type: FilterTypesEnum.tags, title: texts.tagFilter }
            },
            disable: fromPopup === ClassificationEnum.project || uiData.hidecb,
        }
    ])

    useEffect(() => {//filter
        // api calls to get values list for filter
        // setListFilter()
    }, [])

    const fetchProjects = (filter) => new Promise((resolve) => {
        if (isFetching) return;
        const data = {
            refObjectType: ObjectTypeNamesEnum.Application,
            refObjectId: applicationId
        }
        setIsFetching(true);
        projectsApi.projectsFilterRangePost({ projectsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                setIsFetching(false);
                setMyMaterialList({ data: myMaterialList?.data || [], type: ClassificationEnum.project, filteredData: myMaterialList?.filteredData || [] });
                setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Error} title={texts.Error} content={texts.errorFilterProjects} confirmFunc={() => setMessage(false)} />)
            }
            else {
                setIsFetching(false);
                let array = [];
                if (myMaterialList?.data) {
                    let ids = myMaterialList.data.map(p => p.id)
                    // const x = resdata?.filter(p => !ids.includes(p.id));
                    const x = resdata?.filter(p => ids.includes(p.id));
                    array = [...myMaterialList.data, ...x];
                }
                else {
                    array = resdata.sort((a, b) => new Date(b.lastCreatedHistoryDate) - new Date(a.lastCreatedHistoryDate)).map(p => ({ ...p, selected: false }))
                }
                setMyMaterialList({ data: array, type: ClassificationEnum.project, filteredData: filterMyMaterial(myMaterialList?.filter, array), filter: myMaterialList?.filter });
                resolve(array)
            }
        })
    })

    function getMyProjects(refObjectType) {
        const data = {
            refObjectType: getObjectTypeName(refObjectType),
            refObjectId: applicationId
        }
        projectsApi.projectsFilterRangePost({ projectsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                setMyMaterialList({ data: myMaterialList?.data || [], type: ClassificationEnum.project, filteredData: myMaterialList?.filteredData || [] });
                setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Error} confirmFunc={() => setMessage(false)} content={texts.errorFilterProjects} title={texts.Error} />)
            }
            else {
                const newFilter = { ...myMaterialList?.filter, refObjectType };
                let array = resdata.sort((a, b) => new Date(b.lastCreatedHistoryDate) - new Date(a.lastCreatedHistoryDate)).map(p => ({ ...p, selected: false }))
                setMyMaterialList({ data: array, type: ClassificationEnum.project, filteredData: filterMyMaterial(newFilter, array), filter: newFilter });
            }
        })
    }

    function getMyLessons() {
        lessonsApi.lessonsFilterRangePost({ lessonsLastChangedRangeFilter: {} }, (error, resdata, response) => {
            if (error) {
                setMyMaterialList({ data: [], type: ClassificationEnum.lesson, filteredData: [] });
                setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Error} confirmFunc={() => setMessage(false)} content={texts.errorFilterLessons} title={texts.Error} />)
            } else {
                resdata = resdata.map((l, i) => ({ ...l, thumbnail: `${uiData.lessonBG}${(i % 10) + 1}.png` }))
                setMyMaterialList({ data: resdata, type: ClassificationEnum.lesson, filteredData: filterMyMaterial(myMaterialList?.filter, resdata), filter: myMaterialList?.filter });
            }
        })
    }

    const filterMyMaterial = (filter, data) => {
        if (!filter) return data;
        let filteredData = [...data];
        for (const [key, value] of Object.entries(filter)) {
            switch (key) {
                case "free": filteredData = filteredData.filter(x => x.name.includes(value || ''));
                    break;
                case "lang":
                    if (filter.lang) {
                        const filterBy = filter.lang === texts.without ? null : value;
                        filteredData = filteredData.filter(x => x.ide?.lang === filterBy)
                    }
                    break;
                case "ideId":
                    if (filter.ideId) {
                        filteredData = filteredData.filter(x => x.ide?.id === value)
                    }
                    break;
                default:
                    break;
            }
        }
        return filteredData;
    }

    function myMaterialsHandleChange(filter, type) {
        if (myMaterialList?.type !== type) {
            switch (type) {
                case ClassificationEnum.project: getMyProjects(filter.refObjectType);
                    break;
                case ClassificationEnum.lesson: getMyLessons();
                    break;
                default: console.log('an error occoured! type has to be project or lesson');
                    break;
            }
        }
        else {
            if (myMaterialList?.filter?.refObjectType != filter.refObjectType) {
                getMyProjects(filter.refObjectType);
            }
            else {
                const newFilter = { ...myMaterialList.filter, ...filter };
                setMyMaterialList({ ...myMaterialList, filteredData: filterMyMaterial(newFilter, myMaterialList.data), filter: newFilter });
            }
        }
    }

    function projectItemClick(item) {
        if (fromPopup) {
            setSelectedMaterial({ ...item, CB: true })
        }
        else {
            const ideId = JSON.parse(item.contentData)?.Ide?.Id;
            if (ideId !== 1)
                navigate(`${homeUrl}/${PathRouter.LESSONPROJECT}/${item.id}`)
            else
                window.location.href = `${homeUrl}/${PathRouter.LESSONPROJECT}/${item.id}`;
        }
    }

    function auxiliaryItemClick(auxiliary) {
        setMessage(<FilesPopup fileUrl={auxiliary.url} title={auxiliary.name} setMessage={setMessage} />)
    }

    function lessonItemClick(item) {
        if (fromPopup) {
            setSelectedMaterial(item)
        }
        else {
            if (item?.ide?.id !== 1)
                navigate(`${homeUrl}/${PathRouter.CBLESSON}/${item.id}`)
            else
                window.location.href = `${homeUrl}/${PathRouter.CBLESSON}/${item.id}`;
        }
    }

    function handleUploadAuxiliary() {
        setMessage(<UploadAuxiliary setMessage={setMessage} setAddItem={setAddItem} />)
    }

    function handleUploadProject() {
        const data = {
            refObjectType: getObjectTypeName(myMaterialList?.filter?.refObjectType),
            refObjectId: applicationId
        }
        projectsApi.projectsFilterRangePost({ projectsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Error} confirmFunc={() => setMessage(false)} content={texts.MessageContentOldProjects} title={texts.MessageTitleSubmissionsChangeStatus} />)
            }
            else {
                resdata.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)).map(p => p.selected = false)
                setMessage(<UploadContentBankItem classification={ClassificationEnum.project} setAddItem={setAddItem} tabText={texts.singleProject} theTabText={texts.theProject} listFilter={listFilter[0]} items={resdata} closeMessage={() => { setMessage(false) }}></UploadContentBankItem>)
            }
        })

    }

    function handleUploadLesson() {
        const data = {
            refObjectType: ObjectTypeEnum.Application,
            refObjectId: applicationId
        }
        lessonsApi.lessonsFilterRangePost({ lessonsLastChangedRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                console.log('error IN lessonsFilterPost', error)
            } else {
                resdata.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)).map(p => p.selected = false)
                resdata = resdata.map((l, i) => ({ ...l, thumbnail: `${uiData.lessonBG}${(i % 10) + 1}.png` }))
                setMessage(<UploadContentBankItem classification={ClassificationEnum.lesson} tabText={texts.lesson} theTabText={texts.theLesson} setAddItem={setAddItem} listFilter={listFilter[0]} items={resdata} closeMessage={() => { setMessage(false) }} ></UploadContentBankItem>)
            }
        })
    }

    const changeLibraryData = (action, item) => {
        let newMyMaterialList;
        switch (action) {
            case 'CREATE':
                newMyMaterialList = [...myMaterialList.data, ...item];
                setMyMaterialList({ data: newMyMaterialList, type: ClassificationEnum.project, filteredData: filterMyMaterial(myMaterialList?.filter, newMyMaterialList), filter: myMaterialList?.filter });
                break;
            case 'UPDATE':
                newMyMaterialList = [...myMaterialList.data];
                let itemIndex = newMyMaterialList.findIndex(m => m.id == item.id);
                newMyMaterialList[itemIndex] = item;
                setMyMaterialList({ data: newMyMaterialList, type: ClassificationEnum.project, filteredData: filterMyMaterial(myMaterialList?.filter, newMyMaterialList), filter: myMaterialList?.filter });
                break;
            case 'DELETE':
                newMyMaterialList = [...myMaterialList.data];
                newMyMaterialList = newMyMaterialList.filter(m => m.id != item);
                setMyMaterialList({ data: newMyMaterialList, type: ClassificationEnum.project, filteredData: filterMyMaterial(myMaterialList?.filter, newMyMaterialList), filter: myMaterialList?.filter });
                break;
            case 'LOAD': getMyProjects(myMaterialList.filter?.refObjectType);
                break;
            default: console.log('unknown action', action)
                break;
        }
    }

    return (
        <>
            <ContentBank listFilter={listFilter} setAddItem={setAddItem} addItem={addItem} setMyMaterialList={setMyMaterialList} fromPopup={fromPopup} selectedMaterial={selectedMaterial} setSelectedMaterial={setSelectedMaterial}>
                <div
                    classification={ClassificationEnum.project}
                    name="project"
                    handleChange={myMaterialsHandleChange}
                    myMaterialList={<ProjectTypeData changeLibraryData={changeLibraryData} myMaterialList={myMaterialList} setMessage={setMessage} fromPopup={fromPopup} selectedMaterial={selectedMaterial} setSelectedMaterial={setSelectedMaterial} />}
                    uploadText={texts.uploadProject}
                    handleUpload={handleUploadProject}
                    itemClick={(item) => projectItemClick(item)}
                    fromPopup={fromPopup}
                >
                </div>

                <div
                    classification={ClassificationEnum.auxiliary}
                    name="auxiliary"
                    uploadText={texts.uploadAuxiliary}
                    handleUpload={handleUploadAuxiliary}
                    itemClick={(item) => auxiliaryItemClick(item)}
                >
                </div>

                <div
                    classification={ClassificationEnum.lesson}
                    name="lesson"
                    handleChange={myMaterialsHandleChange}
                    myMaterialList={<LessonTypeData changeLibraryData={changeLibraryData} myMaterialList={myMaterialList} setMessage={setMessage} fromPopup={fromPopup} selectedMaterial={selectedMaterial} setSelectedMaterial={setSelectedMaterial} />}
                    uploadText={texts.uploadLesson}
                    handleUpload={handleUploadLesson}
                    itemClick={(item) => lessonItemClick(item)}
                    fromPopup={fromPopup}
                >
                </div>

            </ContentBank>
            {message}
        </>

    )
}

export default ContentBankWrapper;